import { toast as toastify } from 'react-toastify';

const getToastId = (message, options) => {
  if (options?.toastId) return options.toastId;
  if (typeof message === 'string') return message;
  return undefined;
};

const dedupedCall = (method) => (message, options) => {
  const toastId = getToastId(message, options);
  if (toastId && toastify.isActive(toastId)) return;
  return toastify[method](message, { ...options, toastId });
};

export const toast = {
  error: dedupedCall('error'),
  success: dedupedCall('success'),
  warning: dedupedCall('warning'),
  info: dedupedCall('info'),
  dismiss: toastify.dismiss,
  isActive: toastify.isActive,
};
